module.exports = __webpack_public_path__ + "img/dana-icon.e97b156b.svg";